import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchCandidateActiveSubscriptions } from "./CandidateActiveSubscriptionAPI";

// Initial state
const initialState = {
    data: null,         // store the full API response object
    loading: false,
    error: null,
};

// Async thunk to fetch subscriptions
export const fetchCandidateActiveSubscriptionsAsync = createAsyncThunk(
    "CandidateSubscriptionsHistory/fetch",
    async (_, { rejectWithValue }) => {
        try {
            const data = await fetchCandidateActiveSubscriptions(); // full response
            return data; // return the full object: { status, response, code }
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Slice
const CandidateActiveSubscriptionsSlice = createSlice({
    name: "CandidateActiveSubscriptions",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCandidateActiveSubscriptionsAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCandidateActiveSubscriptionsAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload; // store the whole response
                state.error = null;
            })
            .addCase(fetchCandidateActiveSubscriptionsAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            });
    },
});

// Selector to get the whole slice
export const selectCandidateActiveSubscriptions = (state) => state.candidateActiveSubscriptions;

export default CandidateActiveSubscriptionsSlice.reducer;
